export const NAMESPACE = 'nissan-novo-kicks';

export const setFeaturesData = (state: string) => {
  window.localStorage.setItem(
    `${NAMESPACE}.customFeatures`,
    JSON.stringify(state)
  );
};

export const getFeaturesData = (): string => {
  return window.localStorage.getItem(`${NAMESPACE}.customFeatures`) ?? '';
}
